import '../INVC/INVC.scss';
import './QUOT.scss';
import {PageManager} from 'genesis-packages/core';

export default class QUOT extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
